import React, { useState } from "react";
import EAModal from "../../shared/Modal/EAModal";
import { useTranslation } from "react-i18next";
import EADivider from "../../shared/EADivider";
import { AssortGroup } from "../../../models/AssortGroup";
import EAButton from "../../shared/Buttons/EAButton";
import { BsBasket3 } from "react-icons/bs";
import useFacility from "../../../../utils/hooks/useFacility";
import ClubPassRulesMobile from "../ClubPassRules";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import ClubPassRulesDesktop from "../ClubPassRules/ClubPassRulesDesktop";
import CalendarPassMobile from "../CalendarPass";
import CalendarPassDesktop from "../CalendarPass/CalendarPassDesktop";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  pass: AssortGroup;
  selectedDate: Date;
  setDateBetween: (date: Date) => void;
  onAddToBasket: () => void;
}

const PassModal: React.FC<IProps> = ({ isOpen, onClose, pass, selectedDate, setDateBetween, onAddToBasket }) => {
  const [clubCartAgreement, setClubCartAgreement] = useState(false);
  const facilityIds = useFacility();
  const handleCheckboxChange = (event: any) => {
    setClubCartAgreement(event.target.checked);
  };

  const { t } = useTranslation();
  const [readMore, setReadMore] = useState(false);
  const isDesktop = useDesktopSize();

  return (
    <EAModal isOpen={isOpen} title={pass.name} onClose={onClose} hideButtons>
      <div className="pass-modal-container">
        <div className="pass-modal-block pass-modal-product-info">
          {pass.picture && <img alt="Miniatura zdjęcia produktu" src={pass.picture} />}

          {isDesktop && <h4>{pass.name}</h4> }

          <p
            className="pass-modal-product-info__description"
            dangerouslySetInnerHTML={{ __html: pass.description }}
          ></p>

          {pass.description.length > 6 && (
            <EAButton variant="outlined" title="Czytaj więcej" fullWidth onClick={() => setReadMore(true)} />
          )}
        </div>

        <div className="pass-modal-block pass-modal-date-choice">
          {isDesktop && <h5>{t("wybierz_date_rozpoczecia")}</h5>}

          <EADivider />

          {pass.passtype === 8 ? (
            <>
              {isDesktop ? (
                <ClubPassRulesDesktop
                  ids={facilityIds}
                  item={pass}
                  selectedDate={selectedDate}
                  setDateBetween={setDateBetween}
                />
              ) : (
                <ClubPassRulesMobile
                  ids={facilityIds}
                  item={pass}
                  selectedDate={selectedDate}
                  setDateBetween={setDateBetween}
                />
              )}
            </>
          ) : (
            <>
              {isDesktop ? (
                <CalendarPassDesktop
                  ids={facilityIds}
                  selectedDate={selectedDate}
                  setDateBetween={setDateBetween}
                  item={pass}
                />
              ) : (
                <CalendarPassMobile
                  ids={facilityIds}
                  selectedDate={selectedDate}
                  setDateBetween={setDateBetween}
                  item={pass}
                />
              )}
            </>
          )}

          {pass.passtype === 8 && (
            <>
              {clubCartAgreement ? (
                <div className="pass-modal-button">
                  <EAButton title={t("dodaj_do_koszyka")} endIcon={<BsBasket3 />} onClick={onAddToBasket} fullWidth />
                </div>
              ) : (
                <label className="custom-checkbox-label">
                  <input
                    type="checkbox"
                    checked={clubCartAgreement}
                    onChange={handleCheckboxChange}
                    className="custom-checkbox"
                  />
                  <span>
                    Akceptuję{" "}
                    <a href="https://www.parkwodny.pl/fitpark/regulamin/" target="_blank" rel="noreferrer">
                      {" "}
                      warunki korzystania
                    </a>{" "}
                    z Karty Klubowej Imiennej FitPark Open na 2 miesiące.
                  </span>
                </label>
              )}
            </>
          )}

          {pass.passtype !== 8 && (
            <div className="pass-modal-button">
              <EAButton title={t("dodaj_do_koszyka")} endIcon={<BsBasket3 />} onClick={onAddToBasket} fullWidth />
            </div>
          )}
        </div>
      </div>

      <EAModal
        isOpen={readMore}
        title={pass.name}
        onClose={() => setReadMore(false)}
        cancelButtonLabel={t("przeczytalem")}
        hideAcceptButton
      >
        <p dangerouslySetInnerHTML={{ __html: pass.description }}></p>
      </EAModal>
    </EAModal>
  );
};

export default PassModal;
